import Vue from 'vue'
import MyButton from './MyButton.vue'

Vue.component('my-button', MyButton)
